var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloppyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4367 6.87422L17.6258 3.06328C17.45 2.8875 17.2344 2.75859 17 2.68828V2.625H3.875C3.46016 2.625 3.125 2.96016 3.125 3.375V20.625C3.125 21.0398 3.46016 21.375 3.875 21.375H21.125C21.5398 21.375 21.875 21.0398 21.875 20.625V7.93359C21.875 7.53516 21.718 7.15547 21.4367 6.87422ZM9.5 4.3125H15.5V6.75H9.5V4.3125ZM20.1875 19.6875H4.8125V4.3125H8V7.5C8 7.91484 8.33516 8.25 8.75 8.25H16.25C16.6648 8.25 17 7.91484 17 7.5V4.82344L20.1875 8.01094V19.6875ZM12.5 10.3594C10.6367 10.3594 9.125 11.8711 9.125 13.7344C9.125 15.5977 10.6367 17.1094 12.5 17.1094C14.3633 17.1094 15.875 15.5977 15.875 13.7344C15.875 11.8711 14.3633 10.3594 12.5 10.3594ZM12.5 15.6094C11.4641 15.6094 10.625 14.7703 10.625 13.7344C10.625 12.6984 11.4641 11.8594 12.5 11.8594C13.5359 11.8594 14.375 12.6984 14.375 13.7344C14.375 14.7703 13.5359 15.6094 12.5 15.6094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyIcon);
export default __webpack_public_path__ + "static/media/floppy-icon.9e3f197ab2bf30edfe526f36e7f5d308.svg";
export { ForwardRef as ReactComponent };